function composeURLSearch(queryParams = {}) {
    const searchParams = new URLSearchParams();
    for (const [key, value] of Object.entries(queryParams))if (null != value && '' !== value) searchParams.append(key, String(value));
    const searchParamsString = searchParams.toString();
    return searchParamsString ? `?${searchParamsString}` : '';
}
export { composeURLSearch };
